import React from 'react';

// Make hatTarget 'ref="hatTarget"'
// Add '.fill' to all body elements
// Add '.fill--face' to nose

class HeadHOC extends React.Component {
	componentDidMount() {
		this.props.getHatTargetCoords(this.refs.hatTarget);
	}
}

export default class Heads extends HeadHOC {
	render() {
		return (
			<g>
				<circle ref="hatTarget" cx="108.0065765" cy="275.2041931" r="0" />
				<path className="fill fill--alt" d="M78.6175537,306.1664124
					c-0.5605316-1.4047852-0.8212814-2.9166565-0.7986603-4.4289551c0.2975159-19.8843689,5.7018585-38.9046021,27.4036102-38.9046021
					c44.112793-1.5108948,81.3959351,16.9168701,94.1513672,30.3713379
					C177.0821838,321.5604248,90.1616211,335.0974426,78.6175537,306.1664124z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Pet/Tortoise/Heads.js